import React from 'react';
import { AURORA } from '../data/runTheme';
import { useLanguage } from '../i18n/LanguageContext';

const RunSurface: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { language } = useLanguage();
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={language === 'en' ? 'Breathing session' : 'Pusteøkt'}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 50,
        overflow: 'hidden',
        background: AURORA.base,
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'calc(1.5rem + env(safe-area-inset-bottom))',
      }}
    >
      <style>{`
        @keyframes btbDriftA { 0%{transform:translate(-10%,-6%) scale(1)} 100%{transform:translate(8%,10%) scale(1.25)} }
        @keyframes btbDriftB { 0%{transform:translate(12%,4%) scale(1.1)} 100%{transform:translate(-8%,-10%) scale(1.35)} }
        @keyframes btbDriftC { 0%{transform:translate(-4%,12%) scale(1.05)} 100%{transform:translate(6%,-8%) scale(1.2)} }
        .btb-blob{position:absolute;border-radius:50%;filter:blur(60px);opacity:.55}
        .btb-blobA{width:70vmax;height:70vmax;left:-10vmax;top:-15vmax;animation:btbDriftA 24s ease-in-out infinite alternate}
        .btb-blobB{width:60vmax;height:60vmax;right:-12vmax;top:10vmax;animation:btbDriftB 30s ease-in-out infinite alternate}
        .btb-blobC{width:55vmax;height:55vmax;left:15vmax;bottom:-18vmax;animation:btbDriftC 27s ease-in-out infinite alternate}
        @media (prefers-reduced-motion: reduce){ .btb-blobA,.btb-blobB,.btb-blobC{animation:none} }
      `}</style>
      <div className="btb-blob btb-blobA" style={{ background: `radial-gradient(circle, ${AURORA.blobViolet}, transparent 70%)` }} />
      <div className="btb-blob btb-blobB" style={{ background: `radial-gradient(circle, ${AURORA.blobBlue}, transparent 70%)` }} />
      <div className="btb-blob btb-blobC" style={{ background: `radial-gradient(circle, ${AURORA.blobPlum}, transparent 70%)` }} />
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          overflowY: 'auto',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default RunSurface;
